var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMileage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.408 48.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.106 33.534v-.78c0-.446-.111-.78-.223-1.114l14.481-15.372-3.119-3.119L35.762 27.63c-.557-.334-1.671-.223-1.782-.223-3.453 0-6.349 2.785-6.349 6.238a6.228 6.228 0 0 0 6.238 6.238c1.671 0 3.23-.668 4.456-1.894 1.224-1.224 1.781-2.673 1.781-4.455zm29.297 1.226c0 4.344-.891 8.911-2.673 13.478H2.79C.896 44.005.005 39.549.005 34.76-.329 16.045 15.934-.329 34.76.005c18.713-.334 34.977 16.04 34.643 34.755z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileage);
export default __webpack_public_path__ + "static/media/mileage.80d9b96b490c01610b626d0e7ec01e1e.svg";
export { ForwardRef as ReactComponent };